import { useState } from 'react';

import { User } from '@/types/user';

import { getDataTestId } from '@/utils/browser';

import { useMutationWithUserData } from './useMutationWithUserData';

export function useUpdateTermsAndConditions(
  field: keyof User,
  mutateFn?: (payload: { [key: string]: boolean }) => Promise<unknown>,
) {
  const [answered, setAnswered] = useState<boolean>();
  const { mutate, isPending, error, reset } = useMutationWithUserData({
    mutationFn: mutateFn,
  });

  const answer = (value: boolean) => {
    setAnswered(value);
    reset();
    mutate({
      [field]: value,
    });
  };
  const onYes = () => {
    answer(true);
  };
  const onNo = () => answer(false);

  return {
    yesButtonProps: {
      ...getDataTestId(`action-yes-button`),
      onClick: onYes,
      isLoading: answered === true && isPending,
      disabled: isPending,
    },
    noButtonProps: {
      ...getDataTestId(`action-no-button`),
      onClick: onNo,
      isLoading: answered === false && isPending,
      disabled: isPending,
    },
    error,
  };
}
